import { User } from "../../types";
import { v4 as uuid } from "uuid";
import { LOCAL_STORAGE_KEYS } from "../../consts";

export const COLORS = [
  "rgba(254,215,160,1)",
  "rgba(254,196,210,1)",
  "rgba(255,183,180,1)",
  "rgba(255,233,164,1)",
  "rgba(192,241,200,1)",
  "rgba(194,234,253,1)",
  "rgba(218,208,252,1)",
];

export function createUser(name: string, id?: string): User {
  let color =
    window.localStorage.getItem(LOCAL_STORAGE_KEYS.COLOR) ||
    COLORS[Math.floor(Math.random() * COLORS.length)];
  window.localStorage.setItem(LOCAL_STORAGE_KEYS.COLOR, color);

  return {
    // createUser will create an anonymous user until useAuth returns an issuer ID
    id: id || uuid(),
    name: name,
    color,
    anonymous: id === undefined,
    audio: false,
    video: false,
  };
}
